import React from 'react';
import { NavLink, useLocation, useNavigate } from 'react-router-dom';
import { useCart } from '../../context/CartContext';
import { useLang } from '../../context/LangContext';
import { useSession } from '../../context/SessionContext';

function ItemInner({ icon, label, badge, active }) {
  return (
    <>
      <span className={`relative flex items-center justify-center h-8 w-8 rounded-xl text-xl leading-none transition-colors ${active ? 'bg-brand-light text-brand-dark' : ''}`}>
        {icon}
        {badge ? (
          <span className="absolute -top-1.5 -right-2 h-4 min-w-4 px-1 rounded-full bg-gold text-white text-[9px] font-black flex items-center justify-center">
            {badge}
          </span>
        ) : null}
      </span>
      <span className={active ? 'text-brand-dark' : 'text-ink-faint'}>{label}</span>
    </>
  );
}

function Item({ to, icon, label, badge, onClick, forceActive }) {
  const cls = 'flex flex-col items-center justify-center gap-0.5 flex-1 py-2 text-[11px] font-bold';
  if (onClick) {
    return (
      <button type="button" onClick={onClick} className={cls}>
        <ItemInner icon={icon} label={label} badge={badge} active={forceActive} />
      </button>
    );
  }
  return (
    <NavLink to={to} end={to === '/'} className={cls}>
      {({ isActive }) => <ItemInner icon={icon} label={label} badge={badge} active={isActive} />}
    </NavLink>
  );
}

export default function BottomNav() {
  const { lang } = useLang();
  const { itemCount } = useCart();
  const { sessionUser } = useSession();
  const navigate = useNavigate();
  const location = useLocation();
  const te = lang === 'te';

  return (
    <nav
      aria-label="Main"
      className="md:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-black/5 shadow-nav flex safe-bottom"
    >
      <Item to="/" icon="🏠" label={te ? 'హోమ్' : 'Home'} />
      <Item to="/categories" icon="📂" label={te ? 'కేటగిరీలు' : 'Categories'} />
      <Item to="/cart" icon="🛒" label={te ? 'కార్ట్' : 'Cart'} badge={itemCount > 0 ? itemCount : null} />
      <Item to="/orders" icon="📦" label={te ? 'ఆర్డర్లు' : 'Orders'} />
      <Item
        icon="👤"
        label={te ? 'మీరు' : 'You'}
        forceActive={location.pathname.startsWith('/profile') || location.pathname === '/signup'}
        onClick={() => navigate(sessionUser ? '/profile' : '/signup')}
      />
    </nav>
  );
}
